import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import login from "../views/account/login";
import Error500 from "../views/auth/errors/Error500";
const routes = [
  {
    path: '/',
    name: 'Login',
    component: login
  },
  {
    path: '/error',
    name: 'Error',
    component: Error500
  },
  {
    path: '/:pathMatch(.*)*',
    component: Error500
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { left: 0, top: 0 }
  }
})

export default router
